import React, { useState, useRef } from 'react'; 
import './InputBar.css';
import AddIcon from '../../../importfiles/Addfile.png'

const MAX_ROWS = 4;

const InputBar = ({ onSend, onFileUpload }) => {
    const [inputValue, setInputValue] = useState('');
    const textareaRef = useRef(null);

    const resetTextareaHeight = () => {
        if (textareaRef.current) {
            textareaRef.current.style.height = 'auto';
        }
    };

    const autoResize = () => {
        const el = textareaRef.current;
        if (!el) return;
        // Reset per calcolare correttamente lo scrollHeight
        el.style.height = 'auto';
        const lineHeight = parseFloat(getComputedStyle(el).lineHeight);
        const paddingTop = parseFloat(getComputedStyle(el).paddingTop);
        const paddingBottom = parseFloat(getComputedStyle(el).paddingBottom);
        const maxHeight = lineHeight * MAX_ROWS + paddingTop + paddingBottom;
        el.style.height = `${Math.min(el.scrollHeight, maxHeight)}px`;
        el.style.overflowY = el.scrollHeight > maxHeight ? 'auto' : 'hidden';
    };

    const handleChange = (e) => {
        setInputValue(e.target.value);
        autoResize();
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (inputValue.trim()) {
            onSend(inputValue);
            setInputValue('');
            resetTextareaHeight();
        }
    };

    const handleKeyDown = (e) => {
        // Invio per inviare, Shift+Invio per andare a capo
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSubmit(e);
        }
    };

    return (
        <form onSubmit={handleSubmit} className="input-bar-container"> 
            
            <button type="button" className="add-button" onClick={() => document.getElementById('file-upload').click()}>
                <img src={AddIcon} alt="Add file" style={{ width: '20px', height: '20px' }} />
            </button>

            <input
                type="file"
                id="file-upload"
                style={{ display: 'none' }} 
                onChange={(e) => {
                    if (e.target.files && e.target.files.length > 0) {
                        const fileFisico = e.target.files[0];
                        onFileUpload && onFileUpload(fileFisico); //riga 30
                    }
                    e.target.value = null; 
                }}
            />
           
            <textarea
                ref={textareaRef}
                rows={1}
                className="chat-input"
                placeholder="Ask me anything..." 
                value={inputValue}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
            />
            
            <button type="submit" className="send-button-pill">
                <span className="send-icon-arrow">↑</span> 
            </button>
        </form>
    );
};

export default InputBar;